import {checkFetchStatus, clearErrors} from "@stofloos/actions/auth";
import {API_HOST} from "@stofloos/actions/crud";
import {changePage, loadAuthResources} from "@stofloos/actions/app";

export const UPDATE_LOCATION = 'UPDATE_LOCATION';
export const RECEIVE_LAZY_RESOURCES = 'RECEIVE_LAZY_RESOURCES';
export const SET_ANNOUNCER_LABEL = 'SET_ANNOUNCER_LABEL';
export const CLEAR_ANNOUNCER_LABEL = 'CLEAR_ANNOUNCER_LABEL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const UPDATE_NETWORK_STATUS = 'UPDATE_NETWORK_STATUS';
export const CLOSE_NETWORK_TOAST = 'CLOSE_NETWORK_TOAST';
export const TOGGLE_SIDEMENU = 'TOGGLE_SIDEMENU';
export const SET_APP_CONFIG = 'SET_APP_CONFIG';
export const CLOSE_MENU = 'CLOSE_MENU';

import map from 'lodash-es/map';

export const getAppSettings = () => {
        const url = './data/example.json';

        return (dispatch, getState) => new Promise((resolve, reject) => {
            const state = getState();
            fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + state.StofwareAuth.access_token
                }
            })
            .then(res => res.json())
            .then(data => {
                const config = data.config;
                dispatch({
                    type: SET_APP_CONFIG,
                    config,
                });
                resolve();
            });
        });
};

export const reloadPage = () => async (dispatch, getState) => {
    let state = getState();
    const page = state.app.page;
    if (['shop'].indexOf(page) === -1) {
        return;
    }

    dispatch({
        type: UPDATE_LOCATION,
        page: 'Login',
    });
};

export const updateLocation = (location) => async (dispatch, getState) => {
    dispatch(clearErrors());
    dispatch(closeMenu());

    const path = window.decodeURIComponent(location.pathname);
    const splitPath = (path || '').slice(1).split('/');
    let page = splitPath[0];
    let pageId = splitPath[2];
    let endpoint;
    //if (getState().StofwareAuth.isAuthenticated) {
    let module;
    switch (page) {
        case 'bestelling':
            pageId = splitPath[1];
            page = 'bestelling';
            break;
        case 'congres':
            page = 'congres';
        break;
        default:
            page = '/home';
            dispatch(changePage(page));
            dispatch(announceLabel(`Pagina niet gevonden`));
    }
    // } else {
    //     dispatch(loadAuthResources(window.location));
    // }

    dispatch({
        type: UPDATE_LOCATION,
        page,
        pageId,
        endpoint
    });
};

const setAnnouncerLabel = (label) => {
    return {
        type: SET_ANNOUNCER_LABEL,
        label
    };
};

const clearAnnouncerLabel = () => {
    return {
        type: CLEAR_ANNOUNCER_LABEL
    };
};

let announcerTimer = 0;

export const announceLabel = (label) => (dispatch) => {
    dispatch(clearAnnouncerLabel());
    // Debounce announcements.
    clearTimeout(announcerTimer);
    announcerTimer = setTimeout(() => {
        dispatch(setAnnouncerLabel(label));
    }, 300);
};

export const closeMenu =() => {
    return {
        type: CLOSE_MENU
    }
};

export const toggleSidemenu =() => {
    return {
        type: TOGGLE_SIDEMENU
    }
};
export const closeModal = () => {
    return {
        type: CLOSE_MODAL
    };
};

let toastTimer = 0;

export const updateNetworkStatus = (offline) => (dispatch, getState) => {
    const prevOffline = getState().app.offline;
    dispatch({
        type: UPDATE_NETWORK_STATUS,
        offline
    });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => dispatch({ type: CLOSE_NETWORK_TOAST }), 3000);

    if (!offline && prevOffline) {
        dispatch(reloadPage());
    }
};

const isFetchProductFailed = (product) => {
    return !product.isFetching && product.failure;
}